import { createFileRoute, redirect } from '@tanstack/react-router'

import { LoadingSpinner } from '@/components/LoadingSpinner'
import { PageContent } from '@/components/page-content'
import { PageMenu } from '@/components/page-menu'
import { Skeleton } from '@/components/ui/skeleton'
import { userQueryOptions } from '@/modules/user/presentation/hooks/useUsers'
import { ApplicantPage } from '@/modules/user/presentation/pages/applicants/ApplicantPage'
import { applicantSearchSchema } from '@/modules/user/presentation/pages/schemas/applicant-search.schema'
import { getFullName } from '@/shared/utils/string'

export const Route = createFileRoute('/_authenticated/applicants/$applicantId')({
  beforeLoad: ({ params: { applicantId } }) => {
    if (applicantId === 'tags') {
      throw redirect({ to: '/applicants' })
    }
  },
  component: ApplicantPage,
  head: ({ loaderData }) => ({
    meta: [
      {
        title: `Applicants : ${loaderData}`,
      },
    ],
  }),
  loader: async ({ context: { queryClient }, params: { applicantId } }) => {
    const response = await queryClient.ensureQueryData(userQueryOptions(applicantId))
    return getFullName(response.applicant)
  },
  pendingComponent: () => (
    <>
      <PageMenu>
        <Skeleton className="h-6 w-16" />
        <Skeleton className="h-6 w-56" />
      </PageMenu>
      <PageContent>
        <LoadingSpinner />
      </PageContent>
    </>
  ),
  validateSearch: applicantSearchSchema,
})
